import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./contact-skeleton.css";

const ContactSkeleton = () => {
  const skeletonVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0.5 },
    visible: { opacity: 1 },
  };

  return (
    <motion.section
      className="contact section"
      id="contact"
      initial="hidden"
      animate="visible"
      variants={skeletonVariants}
    >
      {/* Title and Subtitle */}
      <motion.h2
        className="section__title skeleton-title-large"
        variants={itemVariants}
      />
      <motion.span
        className="section__subtitle skeleton-subtitle"
        variants={itemVariants}
      />

      {/* Contact Container */}
      <motion.div className="contact__container container grid">
        {/* Left Side: Talk to me - Contact Cards */}
        <motion.div
          className="contact__content"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Title */}
          <motion.h3
            className="skeleton-contact-title"
            variants={itemVariants}
          />

          {/* Contact Cards Grid */}
          <div className="skeleton-contact-cards">
            {/* Card 1 - Email */}
            <motion.div
              className="skeleton-contact-card"
              variants={itemVariants}
            >
              <motion.div
                className="skeleton-contact-icon"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-text"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-subtext"
                variants={itemVariants}
              />
            </motion.div>

            {/* Card 2 - Whatsapp */}
            <motion.div
              className="skeleton-contact-card"
              variants={itemVariants}
            >
              <motion.div
                className="skeleton-contact-icon"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-text"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-subtext"
                variants={itemVariants}
              />
            </motion.div>

            {/* Card 3 - Messenger */}
            <motion.div
              className="skeleton-contact-card"
              variants={itemVariants}
            >
              <motion.div
                className="skeleton-contact-icon"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-text"
                variants={itemVariants}
              />
              <motion.div
                className="skeleton-contact-card-subtext"
                variants={itemVariants}
              />
            </motion.div>
          </div>
        </motion.div>

        {/* Right Side: Write me your project - Form */}
        <motion.div
          className="contact__content"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Form Title */}
          <motion.h3
            className="skeleton-contact-title"
            variants={itemVariants}
          />

          {/* Form Inputs */}
          <div className="skeleton-form-container">
            {/* Name Input */}
            <motion.div
              className="skeleton-form-input"
              variants={itemVariants}
            />
            {/* Email Input */}
            <motion.div
              className="skeleton-form-input"
              variants={itemVariants}
            />
            {/* Project Textarea */}
            <motion.div
              className="skeleton-form-textarea"
              variants={itemVariants}
            />
            {/* Submit Button */}
            <motion.div
              className="skeleton-form-button"
              variants={itemVariants}
            />
          </div>
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default ContactSkeleton;
